require('../../core/require');
require('./page.css');
